import styled from 'styled-components';

export const MarkdownStyled = styled.div`
	--hairline-color: color-mix(in srgb, currentColor 20%, transparent);

	ul,
	ol {
		margin: 8px 0;
		padding-left: 20px;
	}
	ul {
		list-style: disc;
	}
	ol {
		list-style: decimal;
	}
	li + li {
		margin-top: 4px;
	}

	li::marker {
		color: currentColor;
	}

	p,
	li {
		line-height: 20px;
	}

	p {
		margin: 8px 0;
	}
	p:first-child {
		margin-top: 0;
	}
	p:last-child {
		margin-bottom: 0;
	}

	hr {
		border-bottom: 1px solid var(--hairline-color);
	}

	table {
		--table-border-radius: 8px;
		border-radius: var(--table-border-radius);
		margin-block: 16px;

		th:first-child {
			border-top-left-radius: var(--table-border-radius);
		}
		th:last-child {
			border-top-right-radius: var(--table-border-radius);
		}

		tr:last-child > td:first-child {
			border-bottom-left-radius: var(--table-border-radius);
		}

		tr:last-child > td:last-child {
			border-bottom-right-radius: var(--table-border-radius);
		}
	}

	table,
	th,
	td {
		border: 0.5px solid var(--hairline-color);
		border-spacing: 0;
		text-align: left;
	}

	th,
	td {
		padding: 8px;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin: 20px 0 4px;
		font-weight: bold;
		font-family: ${({ theme }) => theme.fontFamilies.heading};
	}
	h1 {
		font-size: 18px;
		line-height: 24px;
	}
	h2 {
		font-size: 16px;
		line-height: 22px;
	}
	h3,
	h4,
	h5,
	h6 {
		font-size: 14px;
		line-height: 20px;
	}
	h1:first-child,
	h2:first-child,
	h3:first-child,
	h4:first-child,
	h5:first-child,
	h6:first-child {
		margin-top: 0;
	}
`;
